module.exports = __webpack_public_path__ + "static/media/VoterID FRONT.14524c7c.jpg";